import Program from '@components/coaching/program';

const ProgramComponent = () => {
  return <Program />;
};

export default ProgramComponent;
